<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Personal de apoyo</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-dialog-content class="p-16 pb-0 m-0">
        <div fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column">
            <table class="simple">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Nombre</th>
                        <th>Rut</th>
                        <th>Ficha</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let persona of personalApoyo; let idx = index">
                        <td>{{ idx + 1 }}</td>
                        <td>{{ persona.nombres }} {{ persona.apellidos }}</td>

                        <td>
                            {{ persona.rut }}
                        </td>
                        <td>
                            <button
                            mat-button
                            color="accent"
                            (click)="verFicha(persona.rut)"
                        >
                            <mat-icon>people_outline</mat-icon>
                            VER FICHA
                        </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </mat-dialog-content>

    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-raised-button color="accent" mat-dialog-close>
            Cerrar
        </button>
    </mat-dialog-actions>
</div>
